export const loadPage = (component, {url: link}, options) => {
  const loading = new Promise(function (resolve, reject) {
    component.$f7.mainView.router.load({url: link})
    resolve(link)
  })
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}



// WEBPACK FOOTER //
// ./src/helpers/routing.js